interface UserAvatarProps {
  avatarUrl: string | null | undefined;
  name: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-xl',
};

export default function UserAvatar({ avatarUrl, name, size = 'md', className = '' }: UserAvatarProps) {
  const sizeClass = sizeClasses[size];
  const initials = name
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={name}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-[#C8A96E]/20 border border-[#C8A96E]/30 flex items-center justify-center flex-shrink-0 ${className}`}
    >
      <span className="text-[#C8A96E] font-semibold">{initials || '?'}</span>
    </div>
  );
}
